import { DataAttributeDefinitions } from 'scrivito'

import { pisaFilterDataClass } from './Pisa/pisaFilterDataClass'

// Attributes are dynamically handled by Scrivito based on API response
// The REST API returns: _id, title, entity, favorite, kind, query, contact, createdAt, createdBy, updatedAt, updatedBy
const attributes: DataAttributeDefinitions = {}

export const Filter = pisaFilterDataClass(attributes)
